export const ACCESS_TOKEN = 'UCS-AUTHEN-TOKEN'
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'
export const DEFAULT_THEME = 'DEFAULT_THEME'
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE'
export const SSO_SYS_TOKEN = 'sso_sys_token'
